<template>
  <div class="addin-wrapper">
    <NotifyBar />
    <!-- 顶部：Logo + 产品标题 -->
    <div class="addin-header">
      <img src="/300px.png" alt="TK图标" class="header-logo" />
      <div class="header-text">
        <div class="title">隧道超前地质预报</div>
        <div class="sub-title">让隧道超报更简单</div>
      </div>
    </div>
    <!-- 中部：SPA路由切换区 -->
    <div class="addin-content">
      <router-view />
    </div>
    <!-- 底部固定导航 -->
    <div class="bottom-nav">
      <!-- <router-link class="nav-item" to="/login">权限认证</router-link>
      <router-link class="nav-item" to="/download">模版下载</router-link>
      <router-link class="nav-item" to="/forecast">地质预报</router-link> -->
      <div class="nav-item" :class="{ active: currentPath === '/login' }" @click="goTo('/login')">
        权限认证
      </div>
      <div class="nav-item" :class="{ active: currentPath === '/download' }" @click="goTo('/download')">
        模版下载
      </div>
      <div class="nav-item" :class="{ active: currentPath === '/forecast' }" @click="goTo('/forecast')">
        地质预报
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { computed } from 'vue'
import NotifyBar from '@/components/NotifyBar.vue'
const router = useRouter()
const route = useRoute()
const currentPath = computed(() => route.path)
function goTo(path: string) {
  if (router) {
    router.push(path)
  } else {
    console.error('路由未初始化')
  }
}
</script>

<style scoped>
.addin-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;
}

.addin-header {
  padding: 28px 20px;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.header-logo {
  width: 120px;
  height: 120px;
}

.header-text {
  text-align: center;
}

.title {
  font-size: 24px;
  color: #333333;
  font-weight: 500;
}

.sub-title {
  font-size: 20px;
  color: #666666;
  margin-top: 8px;
}

.addin-content {
  flex: 1;
  padding: 30px 24px;
  overflow-y: auto;
}

.bottom-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #eeeeee;
  background-color: #fff;
}

.nav-item {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding: 12px 0;
  transition:
    color 0.2s,
    background-color 0.2s;
}

.nav-item:hover {
  color: #4096ff;
  background-color: #e6f4ff;
}

.nav-item.active {
  color: #1677ff;
  font-weight: 500;
  background-color: #f0f7ff;
}
</style>
